/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_View_Guild_InsightsInputs */



/**
* | output |
* | --- |
* | "View Server Insights" |
*
* @param {Leveling_Perm_View_Guild_InsightsInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_view_guild_insights = /** @type {((inputs?: Leveling_Perm_View_Guild_InsightsInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_View_Guild_InsightsInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Просматривать аналитику сервера")
	return /** @type {LocalizedString} */ ("View Server Insights")
});